import { create } from 'zustand'
import { message } from 'antd'
import { AxiosError } from 'axios'
import { axiosInstance, axiosInstanceWithoutInterceptors, paths, setAccessToken } from '@/shared'
import { ApiError } from '@/types'

interface AuthStore {
  isLoggedIn: boolean
  isLoading: boolean
  state: 'login'
  login: (formData: { email: string; password: string; code?: string }) => void
  logout: () => void
}

export const useAuthStore = create<AuthStore>((set) => ({
  isLoggedIn: false,
  isLoading: false,
  state: 'login',
  login: async (formData) => {
    try {
      set({ isLoading: true })
      const { data } = await axiosInstanceWithoutInterceptors.post<{
        access_token: string
        token_type: string
        expires_in: number
      }>('/auth/login', formData)

      set({ isLoggedIn: true })

      const params = new URLSearchParams(window.location.search)
      const from = params.get('from')

      setAccessToken(`${data.token_type} ${data.access_token}`)
      localStorage.setItem('access_token', `${data.token_type} ${data.access_token}`)

      window.location.href = from || paths.main()
    } catch (error) {
      const axiosError = error as AxiosError<ApiError>
      const detail = axiosError.response?.data?.detail
      const errorMessage = typeof detail === 'string' ? detail : (detail?.reason ?? detail?.msg ?? String(error))

      message.error(errorMessage)
    } finally {
      set({ isLoading: false })
    }
  },
  logout: async () => {
    try {
      await axiosInstance.post('/auth/logout')

      set({ isLoggedIn: false })

      const params = new URLSearchParams()
      params.set('from', window.location.pathname)
      window.location.href = '/login?' + params.toString()
    } catch (e) {
      message.error(String(e))
    }
  },
}))
